import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import InvoiceHeader from "../InvoiceHeader";
import InvoiceDetails5 from "../invoiceDetails/InvoiceDetails5";
import InvoiceDetailsRow from "../invoiceDetails/InvoiceDetailsRow";
import InvoiceFooter from "../InvoiceFooter";
import ExciseServiceTable from "./ExciseServiceTable";
import { InvoiceDataType } from "../../../api/invoice";

type ComponentProps = { data?: InvoiceDataType };

const ComponentOne: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceHeader data={data} />
);
const ComponentTwo: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow rowIndex={0} data={data} />
);
const ComponentThree: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow rowIndex={1} data={data} />
);
const ComponentFour: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow rowIndex={2} data={data} />
);
const ComponentFive: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow rowIndex={3} data={data} />
);
const ComponentSix: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetails5 data={data} />
);
const ComponentSeven: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetails5 showOnlyPlaceOfSupply data={data} />
);
const ComponentEight: React.FC<ComponentProps> = ({ data }) => (
  <ExciseServiceTable data={data} />
);
const ComponentNine: React.FC = () => <InvoiceFooter />;

// Row configuration where each row specifies whether it spans two columns and the components to render
const rows = [
  { components: [ComponentOne], spanTwoColumns: true },
  { components: [ComponentTwo, ComponentThree], spanTwoColumns: false },
  { components: [ComponentFour, ComponentFive], spanTwoColumns: false },
  { components: [ComponentSix, ComponentSeven], spanTwoColumns: false },
  { components: [ComponentEight], spanTwoColumns: true },
  { components: [ComponentNine], spanTwoColumns: true },
];

const ExciseInvoiceScreen: React.FC<ComponentProps> = ({ data }) => {
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table
          sx={{ "& .MuiTableCell-root.MuiTableCell-root": { padding: "0px" } }}
        >
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row.spanTwoColumns ? (
                  // Render the row with components that span both columns
                  <TableCell colSpan={2} sx={{ textAlign: "center" }}>
                    {row.components.map((Component, index) => (
                      <Component key={index} data={data} />
                    ))}
                  </TableCell>
                ) : (
                  // Render the row with components in two separate columns
                  <>
                    {row.components.map((Component, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          borderRight: index === 0 ? "3px solid black" : "",
                          borderBottom: "3px solid black",
                          verticalAlign: "top",
                          width: "50%",
                        }}
                      >
                        <Component data={data} />
                      </TableCell>
                    ))}
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ExciseInvoiceScreen;
